var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconStore = function SvgIconStore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.099,
    height: 18.153,
    viewBox: "0 0 20.099 18.153",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804",
    transform: "translate(3201.253 -1749.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M388.151,305.961v8.019h16.665v-8.019h.489V314.4H387.662v-8.439Z",
    transform: "translate(-3587.668 1452.757)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M409.265,316.858v4.326h11.594v-4.326Zm11.146,3.878h-10.7v-3.43h10.7Z",
    transform: "translate(-3606.247 1443.386)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M399.454,236.579H381.76a.91.91,0,0,0,0,1.819h17.695a.91.91,0,1,0,0-1.819Zm.122,1.383H381.637c-.185,0-.335-.212-.335-.473s.15-.473.335-.473h17.939c.185,0,.335.212.335.473S399.762,237.962,399.576,237.962Z",
    transform: "translate(-3581.81 1512.425)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    transform: "translate(-3201 1750.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M493.112,255.737c.306.906,1.234,2.067,2.2,1.9a1.971,1.971,0,0,0,1.6-2.281l-1.014-5.781",
    transform: "translate(-477.354 -249.571)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M381.611,249.571l-1.014,5.781a1.971,1.971,0,0,0,1.6,2.281h0a2.311,2.311,0,0,0,2.394-1.9",
    transform: "translate(-380.567 -249.571)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M409.309,293.61h0a1.971,1.971,0,0,0,1.97,1.971h0a1.971,1.971,0,0,0,1.97-1.971",
    transform: "translate(-405.285 -287.444)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M441.4,293.61a1.971,1.971,0,0,1-1.971,1.971h0a1.971,1.971,0,0,1-1.971-1.971",
    transform: "translate(-429.491 -287.444)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M469.456,293.61c-.25.8-1,1.971-1.881,1.971h0a1.971,1.971,0,0,1-1.97-1.971",
    transform: "translate(-453.698 -287.444)",
    fill: "none",
    stroke: "#173a6d",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_store.a69476eb.svg";
export { ForwardRef as ReactComponent };